import moment from 'moment'

export default class Patient {
  constructor (id, name, birthDate, gender, photo, country, immunizations, plan) {
    this._id = id.toString()
    this._name = name
    this._birthDate = birthDate
    this._gender = gender
    this._photo = photo
    this._country = country
    this._immunizations = immunizations
    this._plan = plan
  }

  get id () {
    return this._id
  }

  get name () {
    return this._name
  }
  get birthDate () {
    return this._birthDate
  }
  get gender () {
    return this._gender
  }
  get photo () {
    return this._photo
  }
  set photo (value) {
    this._photo = value
  }

  get immunizations () {
    return this._immunizations
  }

  get plan () {
    return this._plan
  }

  getFormattedBirthDate (locale) {
    return moment(new Date(this._birthDate)).format('L')
  }

  get country () {
    return this._country
  }
}
